import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DebtCovenantComplianceFormView } from '../../models/debt-management/DebtCovenantComplianceFormView';
import { UtilityService } from '../utility.service';
import { FormSearch } from 'app/models/dashboard/FormStatus';
import { BaseDashboard } from 'app/models/dashboard/BaseDashboard';

@Injectable({
	providedIn: 'root',
})
export class DebtCovenantComplianceService {
	private readonly urlPath = `${environment.apiUrl}debt-management/clients/`;
	private readonly headers = new HttpHeaders({
		'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
	});

	constructor(private httpClient: HttpClient, private utilityService: UtilityService) {}

	getFormsFor(clientId: string, userId: string, search: FormSearch): Observable<BaseDashboard<any>> {
		const url = `${
			this.urlPath
		}${clientId}/forms/debt-covenant-compliance-form/users/${userId}?${this.utilityService.objectToQueryString(
			search
		)}`;
		return this.httpClient.get<BaseDashboard<any>>(url).pipe();
	}

	createForm(clientId: string, request: DebtCovenantComplianceFormView): Observable<DebtCovenantComplianceFormView> {
		return this.httpClient.post<DebtCovenantComplianceFormView>(
			`${this.urlPath}${clientId}/forms/debt-covenant-compliance-form`,
			request
		);
	}

	updateForm(
		clientId: string,
		id: string,
		request: DebtCovenantComplianceFormView
	): Observable<DebtCovenantComplianceFormView> {
		return this.httpClient.put<DebtCovenantComplianceFormView>(
			`${this.urlPath}${clientId}/forms/debt-covenant-compliance-form/${id}`,
			request
		);
	}

	getForm(clientId: string, id: string): Observable<DebtCovenantComplianceFormView> {
		return this.httpClient.get<DebtCovenantComplianceFormView>(
			`${this.urlPath}${clientId}/forms/debt-covenant-compliance-form/${id}`,
			{ headers: this.headers }
		);
	}

	getAllForms(clientId: string): Observable<DebtCovenantComplianceFormView[]> {
		return this.httpClient.get<DebtCovenantComplianceFormView[]>(
			`${this.urlPath}${clientId}/forms/debt-covenant-compliance-form`
		);
	}

	submitForApproval(clientId: string, id: string): Observable<DebtCovenantComplianceFormView> {
		return this.httpClient.post<DebtCovenantComplianceFormView>(
			`${this.urlPath}${clientId}/forms/debt-covenant-compliance-form/${id}/approval`,
			{}
		);
	}

	sendForReview(clientId: string, id: string): Observable<DebtCovenantComplianceFormView> {
		return this.httpClient.post<DebtCovenantComplianceFormView>(
			`${this.urlPath}${clientId}/forms/debt-covenant-compliance-form/${id}/review`,
			{}
		);
	}

	rejectForm(
		clientId: string,
		id: string,
		rejection: { reason: string; workflowId: number }
	): Observable<DebtCovenantComplianceFormView> {
		return this.httpClient.post<DebtCovenantComplianceFormView>(
			`${this.urlPath}${clientId}/forms/debt-covenant-compliance-form/${id}/decline`,
			rejection
		);
	}

	approveForm(clientId: string, id: string, userId: string): Observable<DebtCovenantComplianceFormView> {
		return this.httpClient.post<DebtCovenantComplianceFormView>(
			`${this.urlPath}${clientId}/forms/debt-covenant-compliance-form/${id}/approve`,
			{ userId }
		);
	}

	cancelSchedule(clientId: string, id: string): Observable<void> {
		return this.httpClient.delete<void>(
			`${this.urlPath}${clientId}/forms/debt-covenant-compliance-form/${id}/cancelSchedule`
		);
	}
}
